export default __webpack_public_path__ + "static/media/Image-Benefit1.0f1d1d58.png";